import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

// Remote, single-select herb picker for the monograph applies-to form. As the
// editor types, it searches existing herbs via the admin JSON endpoint and
// submits the chosen herb's id. create: false is the point — an editor can only
// pick a real herb, never conjure an association from a loose binomial. The
// list caps and min query length keep it client-side (see herb-select url value).
export default class extends Controller {
  static values = { url: String }

  connect() {
    this.select = new TomSelect(this.element, {
      valueField: "value",
      labelField: "text",
      searchField: "text",
      maxItems: 1,
      maxOptions: 20,
      create: false,
      loadThrottle: 300,
      shouldLoad: (query) => query.length > 2,
      load: (query, callback) => {
        fetch(`${this.urlValue}?q=${encodeURIComponent(query)}`)
          .then((response) => response.json())
          .then(callback)
          .catch(() => callback())
      },
    })
  }

  disconnect() {
    this.select?.destroy()
  }
}
